import { i18n } from '@/plugins/i18n';

const MAVEN_CHAT_WIDGET_ID = 'maven-chat-widget';
const MAVEN_CHAT_IFRAME_SELECTOR = 'iframe[data-testid="chat-frame"]';
const IFRAME_TITLE_OBSERVER_TIMEOUT_MS = 10_000;

const { t } = i18n.global;

let iframeTitleObserver: MutationObserver | null = null;

function getMavenChatIframe(): HTMLIFrameElement | null {
	return document.querySelector<HTMLIFrameElement>(MAVEN_CHAT_IFRAME_SELECTOR);
}

function disconnectIframeTitleObserver() {
	iframeTitleObserver?.disconnect();
	iframeTitleObserver = null;
}

function setMavenChatIframeTitle() {
	const iframeTitle = t('mavenChat.iframeTitle');
	const iframe = getMavenChatIframe();

	if (iframe) {
		iframe.title = iframeTitle;
		disconnectIframeTitleObserver();
		return;
	}

	disconnectIframeTitleObserver();

	const observerTarget = document.getElementById(MAVEN_CHAT_WIDGET_ID) ?? document.body;
	iframeTitleObserver = new MutationObserver(() => {
		const chatIframe = getMavenChatIframe();

		if (!chatIframe) return;

		chatIframe.title = iframeTitle;
		disconnectIframeTitleObserver();
	});

	iframeTitleObserver.observe(observerTarget, { childList: true, subtree: true });

	const observer = iframeTitleObserver;
	setTimeout(() => {
		if (iframeTitleObserver === observer) disconnectIframeTitleObserver();
	}, IFRAME_TITLE_OBSERVER_TIMEOUT_MS);
}

export { setMavenChatIframeTitle };
